import { render, staticRenderFns } from "./CTxtlinkList.vue?vue&type=template&id=91291348&"
import script from "./CTxtlinkList.vue?vue&type=script&lang=ts&"
export * from "./CTxtlinkList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports